export { default } from './RateItemCard';
